import img1 from "../home/images/img1.svg";
import call from "../home/images/call.svg";
import net from "../home/images/net.svg";

export const homeProductData = [
  {
    id: 1,
    img: img1,
    title: "Supply to both OEMs and Tier – 1 manufacturers",
  },
  {
    id: 2,
    img: net,
    title: "Flexibility in process",
  },
  {
    id: 3,
    img: call,
    title: "Economical in every way",
  },
  {
    id: 4,
    img: img1,
    title: "Supply to both OEMs and Tier – 1 manufacturers",
  },
];
